/**
 * 准入配置「推送模式」（分批次-尾程）：0-自动（默认，与现网一致）1-手动（仓管在批次推送页推送后 DSP 才可见）。
 * 手动模式只能选 HUB发件 / 仓库到件，可选准入节点由后端按模式返回。
 */
export const PUSH_MODE = {
    AUTO: 0,
    MANUAL: 1,
} as const;

/** 推送模式 → i18n key */
export const pushModeLabelKey = (pushMode: number | null | undefined): string =>
    pushMode === PUSH_MODE.MANUAL ? 'config.entryConfig.pushMode.manual' : 'config.entryConfig.pushMode.auto';

/**
 * 当前准入节点在所选推送模式下是否仍可选；选项尚未加载（空）时视为可选，避免误清空。
 */
export const isEntryNodeAvailable = (
    entryNode: string | null | undefined,
    options: Array<{ value: string }>,
): boolean => !entryNode || options.length === 0 || options.some((o) => o.value === entryNode);
